var _effectorFileName = "/src/pages/legal-notice/index.page.tsx";
import { GetServerSideProps } from 'next';
import { allSettled, fork, serialize } from 'effector';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { LegalNoticePage, legalNoticePage } from '@/page-content/legal-notice';
import { DEFAULT_LOCALE } from '@/shared/config/i18n';
import { EFFECTOR_STATE_KEY } from '@/shared/lib/effector';
import { getPageContext } from '@/shared/lib/effector/page';
export const getServerSideProps: GetServerSideProps = async ctx => {
  const scope = fork();
  const locale = ctx.locale ?? DEFAULT_LOCALE;
  await allSettled(legalNoticePage.open, {
    scope,
    params: getPageContext(ctx)
  });
  return {
    props: {
      [EFFECTOR_STATE_KEY]: serialize(scope),
      ...(await serverSideTranslations(locale, ['common', 'layout-header', 'layout-footer']))
    }
  };
};
export default LegalNoticePage;